module.exports = __webpack_public_path__ + "img/img-validcode.97d12336.svg";